<template>
  <div>
    <iMineTemplate
      :pageTitle="pageTitle"
      :activedParentKey="activedParentKey"
      :activedKey="activedKey"
    >
      <template #rightContent>
        <div class>
          <div class="bgfff pt30 pl20 pr20 order-list">
            <van-tabs
              animated
              v-model="tab_active"
              title-active-color="#0F6EE9"
              line-height="0"
              line-width="0"
              @change="handleTabsChange"
              :class="`tab${Number(tab_active + 1)}`"
              :border="true"
              :scrollspy="false"
              :swipe-threshold="7"
            >
              <van-tab v-for="(item, index) in tabs" :key="index">
                <template #title>
                  <span>{{ item.Name }}</span>
                  <span v-if="item.Count" class="ml10">({{ item.Count }})</span>
                </template>
                <div
                  :class="{ bgfff: !dataList.length }"
                  style="margin-top:22px"
                  v-if="tab_active < 6"
                >
                  <div class="mt5">
                    <iOrderList
                      v-if="dataList && dataList.length"
                      :data="dataList"
                      @handleConfirmGoods="handleConfirmGoods"
                      @goApplyInvoice="goApplyInvoice"
                      @lookApplyInvoice="lookApplyInvoice"
                      @cancelMoney="cancelMoney"
                      @againLoad="againLoad"
                      @goDetails="goDetails"
                      @ViewLogistics="goViewLogistics"
                    />

                    <EmptyControl
                      style="padding-top: 100px;"
                      v-if="!dataList.length && finished"
                      type="order"
                      :text="
                        `还没有${
                          tab_active == 0 ? '' : tabs[tab_active].Name
                        }订单哦～`
                      "
                      homeButton
                    ></EmptyControl>
                  </div>
                </div>
                <div
                  :class="{ bgfff: !refundDataList.length }"
                  style="margin-top:22px"
                  v-else
                >
                  <div class="mt5">
                    <iOrderListRefund
                      v-if="refundDataList && refundDataList.length"
                      :data="refundDataList"
                      @goDetails="goDetails"
                    />

                    <EmptyControl
                      style="padding-top: 100px;"
                      v-if="!refundDataList.length && refundFinished"
                      type="order"
                      :text="
                        `还没有${
                          tab_active == 0 ? '' : tabs[tab_active].Name
                        }订单哦～`
                      "
                      homeButton
                    ></EmptyControl>
                  </div>
                </div>
              </van-tab>
            </van-tabs>
          </div>
          <iPagination
            :currentPage.sync="pageindex"
            :limit.sync="pageSize"
            :totalCount="totalCount"
            @turn="onLoad"
            v-if="dataList && dataList.length && tab_active < 6"
            small
          />
          <iPagination
            :currentPage.sync="page.Pageindex"
            :limit.sync="page.Pagesize"
            :totalCount="page.count"
            @turn="onLoad"
            v-if="refundDataList && refundDataList.length && tab_active === 6"
            small
          />
        </div>
      </template>
    </iMineTemplate>
    <!-- 对话框 -->
    <iDialog
      ref="iDialogref"
      :msg="dialogMsg"
      @confirm="confirmDialog"
      confirmBtnText="确认"
      cancelBtnText="取消"
      :width="dialogMsg == '申请退款' ? '790px' : '560px'"
    >
      <template #bottom>
        <div v-if="dialogMsg == '申请退款'">
          <div class="f18 c222 text-left" style="padding:0 100px">
            可退款金额：
            <span class="f18 cFF3939 fw600 ml5">¥ 192383.08</span>
          </div>
          <div style="padding:15px 100px 30px 100px">
            <van-notice-bar
              wrapable
              :scrollable="false"
              color="#D3691F"
              background="#FFF6D8"
              class="cBABABA pl15 pr15 text-left f14 mt10"
            >
              <van-icon
                :name="require('@/assets/mine/note.png')"
                size="20px"
                class="mr5"
                style="position: relative; top: 5px;"
              />
              注：申请退款后，平台将在1-2个工作日审核。退款金额将原路退回至您付款账户中。
            </van-notice-bar>
          </div>
        </div>
      </template>
    </iDialog>
    <!-- 申请开票弹框 -->
    <van-overlay
      :show="iApplyInvoice"
      @click="iApplyInvoice = false"
      z-index="5"
    >
      <div @click.stop class="wrapper">
        <ApplyInvoiceForm
          isdialog
          @cancel="handleCancelInvoice"
          @confirm="handleConfirmInvoice"
          ref="iApplyInvoice"
        />
      </div>
    </van-overlay>
    <!-- 查看发票弹框 -->
    <van-overlay
      :show="ilookApplyInvoice"
      @click="ilookApplyInvoice = false"
      z-index="5"
    >
      <div @click.stop class="wrapper">
        <ApplyInvoiceForm
          isdialog
          isReadOnly
          @cancel="handleCancellookInvoice"
          ref="ilookApplyInvoice"
        />
      </div>
    </van-overlay>
    <!-- 查看物流弹框 -->
    <van-overlay
      :show="iViewLogistics"
      @click="iViewLogistics = false"
      z-index="5"
    >
      <div @click.stop class="wrapper logistics">
        <ViewLogistics ref="iViewLogistics" @cancel="closeViewLogistics" />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import iDialog from "@/components/iDialog";
import iOrderList from "@/components/iOrderList";
import iOrderListRefund from "@/components/iOrderListRefund";
import { LinkTypeCode } from "@/dictionary/base.js";
import { BaseMixin } from "../../mixins/BaseMixin.js";
export default {
  name: "MyOrder",
  mixins: [BaseMixin],
  components: {
    iOrderList,
    iOrderListRefund,
    iDialog,
  },
  data() {
    return {
      orderInvoiceType: 1,
      pageTitle: ["交易管理", "我的订单"],
      activedParentKey: 2,
      activedKey: 21,
      pageindex: 1,
      pageSize: 10,
      totalCount: 0,
      tab_active: 0,
      tab_activeList: true,
      tabs: [{ key: 0, Name: "全部订单" }],
      dataList: [],
      refundDataList: [],
      finished: false,
      refundFinished: false,
      iViewLogistics: false,
      iApplyInvoice: false,
      ilookApplyInvoice: false,
      dialogMsg: "",
      // 退款数据分页参数
      page: {
        Pageindex: 1, //页数
        Pagesize: 10, //每页条数
        IsPagging: true, //是否开启分页
        count: 0, //总数
      },
    };
  },
  mounted() {
    // 获取订单数量统计
    this.getOrderStateCount();
    this.onLoad();
  },
  methods: {
    // 查看物流
    goViewLogistics(id) {
      this.iViewLogistics = true;
      this.$refs.iViewLogistics.init(id);
    },
    closeViewLogistics() {
      this.iViewLogistics = false;
    },
    handleCancellookInvoice() {
      this.ilookApplyInvoice = false;
    },
    // 申请开票
    goApplyInvoice(item) {
      this.iApplyInvoice = true;
      this.$refs.iApplyInvoice.setApplyInvoiceId(item);
    },
    lookApplyInvoice(id) {
      this.ilookApplyInvoice = true;
      this.$refs.ilookApplyInvoice.setApplyInvoiceId(id);
    },
    // 取消开票
    handleCancelInvoice() {
      this.iApplyInvoice = false;
    },
    // 确认开票
    handleConfirmInvoice() {
      this.iApplyInvoice = false;
      this.againLoad();
    },

    // 确认收货
    handleConfirmGoods(item) {
      this.dialogMsg = "是否确认收货？";
      this.$refs.iDialogref.iShow(item, "receipt");
    },
    // 取消订单
    cancelOrder(item) {
      this.dialogMsg = "是否取消订单？";
      this.$refs.iDialogref.iShow(item, "order");
    },
    // 申请退款
    cancelMoney(item) {
      this.dialogMsg = "申请退款";
      this.$refs.iDialogref.iShow(item, "cancelMoney");
    },
    confirmDialog(data, type) {
      // 申请退款  取消订单
      if (type == "order" || type == "cancelMoney") {
        this.$hys.openLoading();
        const res = this.postAction("/api_order/Orders/CancelOrderV2", {
          OrderId: data.Id,
          OrderNo: data.OrderNo,
        }).then((res) => {
          this.$hys.clearLoading();
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
            return;
          }
          this.$toast.success("取消成功");
          this.againLoad();
        });
        return;
      }
      if (type == "receipt") {
        this.$hys.openLoading();
        const res = this.putAction(
          "/api_order/Orders/ConfirmOrder?orderId=" + data.Id
        ).then((res) => {
          this.$hys.clearLoading();
          if (!res.IsSuccess) {
            this.$toast({ position: "bottom", message: res.Msg });
            return;
          }
          this.$toast.success("收货成功");
          this.againLoad();
        });
        return;
      }
    },
    async againLoad() {
      this.pageindex = 1;
      this.page.Pageindex = 1;
      this.getOrderStateCount();
      await this.loadData();
    },
    // 订单详情
    goDetails(id) {
      if (this.tab_active < 6) {
        this.$router.push({
          path: "OrderDetails",
          query: {
            orderId: id,
          },
        });
      } else {
        this.$router.push({
          path: "OrderRefundDetails",
          query: {
            orderId: id,
          },
        });
      }
    },
    // 获取订单数量统计
    async getOrderStateCount() {
      const res = await this.getAction("/api_order/Orders/GetOrderStateCount");
      if (res.IsSuccess && res.Data) {
        this.tabs = [{ key: 0, Name: "全部订单" }];
        res.Data.map((t, i) => {
          if (t.Name !== "退款售后") {
            let l = {
              key: this.tabs.length + 1,
              ...t,
            };
            this.tabs.push(l);
          }
        });
        // 获取退款数据
        // const refundRes = this.postAction('/api_aftersale/AfterSaleDocment/AfterSaleOrderList', {
        // 	Pageindex: this.page.Pageindex, //页数
        // 	Pagesize: this.page.Pagesize, //行数
        // 	IsPagging: this.page.IsPagging //是否开启分页
        // }).then(refundRes => {
        // 	let l = {
        // 		key: this.tabs.length + 1,
        // 		Count: refundRes.Count,
        // 		Name: '退款/售后'
        // 	};
        // 	this.tabs.push(l);
        // });
      } else {
        this.$toast({ position: "bottom", message: res.Msg });
      }
    },
    // tab 切换
    async handleTabsChange() {
      this.finished = false;
      this.refundFinished = false;
      this.tab_activeList = false;
      this.dataList = [];
      this.refundDataList = [];
      this.pageindex = 1;
      this.page.Pageindex = 1;
      await this.loadData();
      this.tab_activeList = true;
    },

    // 加载数据
    async onLoad() {
      await this.loadData();
    },
    async loadData() {
      let orderState = "";
      let orderPaymentState = "";
      let orderLogisticsState = "";
      switch (this.tab_active) {
        case 1:
          orderState = 1;
          orderPaymentState = 1;
          break;
        case 2:
          orderState = 1;
          orderLogisticsState = 6;
          break;
        case 3:
          orderState = 1;
          orderLogisticsState = 3;
          break;
        case 4:
          orderState = 2;
          orderLogisticsState = 5;
          break;
        case 5:
          orderState = 3;
          break;
        // case 6:
        // 	orderState = '';
        // 	break;
        default:
          orderState = "";
          orderPaymentState = "";
          orderLogisticsState = "";
          break;
      }
      // 判断需要获取哪一种类型数据
      // 获取全部，待付款，待发货，已发货，已收货，已关闭，数据
      if (this.tab_active < 6) {
        this.$hys.openLoading();
        const res = await this.getAction("/api_order/Orders/List", {
          keyword: "",
          orderState: orderState,
          orderPaymentState: orderPaymentState,
          orderLogisticsState: orderLogisticsState,
          pageNo: this.pageindex,
          pageSize: this.pageSize,
        });
        this.$hys.clearLoading();

        this.totalCount = res.Count;
        if (this.pageindex == 1) {
          this.dataList = [];
        }
        if (res.IsSuccess && res.Data.length < this.pageSize) {
          this.finished = true;
        }
        if (res.IsSuccess) {
          // this.dataList=[]
          this.tabs[this.tab_active].index = res.Count;
          let dataArr = [];
          if (res.Data) {
            res.Data.map((item) => {
              let statusName = "";

              if (item.OrderState == 1) {
                if (
                  item.OrderPaymentState == 1 ||
                  item.OrderPaymentState == 2 ||
                  item.OrderPaymentState == 7
                ) {
                  statusName = "待付款";
                } else if (item.OrderLogisticsState == 6) {
                  statusName = "待发货";
                } else if (item.OrderLogisticsState == 3) {
                  statusName = "已发货";
                } else if (item.OrderLogisticsState == 5) {
                  statusName = "已收货";
                }
              } else if (
                item.OrderState == 2 &&
                item.OrderLogisticsState == 5
              ) {
                statusName = "已收货";
              } else if (item.OrderState == 3) {
                statusName = "已关闭";
              }
              let l = {
                ...item,
                status: statusName,
              };
              dataArr.push(l);
            });
          }
          this.dataList = dataArr;
        } else {
          this.$toast({ position: "bottom", message: res.Msg });
          this.finished = true;
        }
      } else {
        // 获取退款/售后 数据
        this.$hys.openLoading();
        const refundRes = this.postAction(
          "/api_aftersale/AfterSaleDocment/AfterSaleOrderList",
          {
            Pageindex: this.page.Pageindex, //页数
            Pagesize: this.page.Pagesize, //行数
            IsPagging: this.page.IsPagging, //是否开启分页
          }
        ).then((refundRes) => {
          this.$hys.clearLoading();
          if (refundRes.IsSuccess) {
            // 设置总数
            this.page.count = refundRes.Count;
            if (this.page.Pageindex === 1) {
              this.refundDataList = [];
            }
            if (refundRes.Data.length < this.page.Pagesize) {
              this.refundFinished = true;
            }
            this.tabs[this.tab_active].index = refundRes.Count;
            if (refundRes.Data) {
              let refundDataArr = [];
              refundRes.Data.forEach((refundItem) => {
                refundItem.status = "已退款";
                refundDataArr.push(refundItem);
              });
              this.refundDataList = refundDataArr;
            }
          } else {
            this.$toast({ position: "bottom", message: refundRes.Msg });
            this.refundFinished = true;
          }
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.order-list {
  border-radius: 2px;
  border: 1px solid rgba(232, 232, 232, 1);
  width: 100%;
  box-sizing: border-box;
  padding-bottom: 30px;
  min-height: 668px;

  /deep/.van-tabs {
    /deep/.van-tabs__wrap {
      border-bottom: 2px solid #3183ec;
    }
  }

  /deep/.van-tab {
    justify-content: flex-start;
    width: 125px;
    flex: none;
    align-items: flex-start;
  }
}

.middle-h {
  left: 0;
  right: 0;
  margin: auto;
}

/deep/.van-overlay {
  .wrapper {
    max-width: 1200px;
    margin: 5% auto;
  }

  .wrapper.logistics {
    width: 960px;
  }
}
</style>
